import { PropTypes } from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submit } from 'redux-form';
import { hideDialog } from '../../../core/actions';
import ModalDialog from '../../../core/components/Modal';
import TodaysTaskInDetail from '../components/TodaysTaskInDetail';

class TaskDetailsDialog extends Component {
  static propTypes = {
    triggerSubmit: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
    taskCompletion: PropTypes.shape({}),
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        site: PropTypes.string.isRequired,
      }).isRequired,
    }),
  };

  render() {
    const { closeDialog, isOpen, taskCompletion, title } = this.props;
    return (
      <ModalDialog
        className="enhanced-dialog padded-minimal task-details"
        title={title}
        onReady={this.onReady}
        showFooter={false}
        isOpen={isOpen}
        close={closeDialog}
      >
        <TodaysTaskInDetail
          {...taskCompletion.task}
          match={this.props.match}
          history={this.props.history}
          _taskId={taskCompletion.task.id}
          hideDrawerControls={true}
        />
      </ModalDialog>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeDialog: hideDialog,
      triggerSubmit: submit,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskDetailsDialog);
